import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FacePositive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M12.85 24.961a.917.917 0 1 0-1.598.898c2.11 3.76 6.137 6.31 10.76 6.31 4.608 0 8.635-2.523 10.748-6.272a.917.917 0 0 0-1.597-.9 10.488 10.488 0 0 1-9.15 5.339c-3.933 0-7.362-2.168-9.163-5.375ZM14.96 18.101a3.005 3.005 0 0 0-2.623 1.537.917.917 0 0 1-1.599-.898 4.839 4.839 0 0 1 4.222-2.472 4.83 4.83 0 0 1 4.236 2.488.917.917 0 0 1-1.603.89 2.997 2.997 0 0 0-2.633-1.545ZM26.405 19.637a3.005 3.005 0 0 1 2.623-1.536c1.135 0 2.117.617 2.633 1.545a.917.917 0 0 0 1.602-.89 4.83 4.83 0 0 0-4.235-2.488c-1.81 0-3.393.996-4.222 2.472a.917.917 0 1 0 1.599.898Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0C9.85 0 0 9.85 0 22s9.85 22 22 22 22-9.85 22-22S34.15 0 22 0ZM1.833 22c0-11.138 9.03-20.167 20.167-20.167 11.138 0 20.167 9.03 20.167 20.167 0 11.138-9.03 20.167-20.167 20.167-11.138 0-20.167-9.03-20.167-20.167Z"
  }));
});
FacePositive.displayName = 'FacePositive';
FacePositive.defaultProps = {
  'aria-label': 'FacePositive'
};
export default FacePositive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FacePositive.js
// module id = 3967
// module chunks = 11